import Router from 'bpm-router';

import { bindEvents } from '../helpers';


class RoutingController {

	constructor() {
		this.selector = '';

		this.events = bindEvents(this);
	}

	start(routes) {
		Router.start(routes);
	}

	_onRouterClick(e) {
		e.preventDefault();
		Router.navigate(e.currentTarget.getAttribute('href'));
	}

	overrideAnchor(container = document) {
		const anchor = container.querySelectorAll(this.selector);
		for (const a of anchor) {
			a.removeEventListener('click', this.events._onRouterClick);
			a.addEventListener('click', this.events._onRouterClick);
		}
	}

}

export default new RoutingController();
